
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-white mb-6">
                About Ebusiness Marketing Group LLC
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                An innovative umbrella company providing cutting-edge AI Agency Services and facilitating strategic establishment and growth of new business entities as DBAs. We empower businesses to thrive in the digital age through intelligent marketing solutions and comprehensive business development support.
              </p>
              <Button href="/contact" variant="primary" size="lg" className="whitespace-nowrap">
                Work With Us
              </Button>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/d284d72deac738ef2474c9b45b1f2d97/66d5cb384bc73851141bee06d411b5fb.jpeg"
                alt="Ebusiness Marketing Group Team"
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-target-line text-2xl text-blue-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                To empower businesses by integrating cutting-edge AI solutions with robust business formation strategies, fostering innovation, growth, and long-term success for our clients. We bridge the gap between advanced technology and strategic business development.
              </p>
            </div>
            
            <div>
              <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-eye-line text-2xl text-green-600"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Vision</h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                To be the premier partner for businesses seeking to leverage artificial intelligence for marketing excellence and streamlined business establishment, setting new industry standards for innovation and client success in the digital transformation era.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              These principles guide everything we do and shape how we work with our clients and each other.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            <div className="bg-white rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Innovation</h3>
              <p className="text-gray-600">
                Continuously seeking and implementing advanced AI and business strategies to stay ahead of industry trends.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Integrity</h3>
              <p className="text-gray-600">
                Upholding the highest ethical standards in all client and business dealings with transparency and honesty.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-trophy-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Excellence</h3>
              <p className="text-gray-600">
                Delivering superior service and measurable results that exceed expectations in every project.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Client-Centricity</h3>
              <p className="text-gray-600">
                Prioritizing client needs and fostering long-term partnerships built on trust and mutual success.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-sm">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-refresh-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Adaptability</h3>
              <p className="text-gray-600">
                Responding proactively to market changes and technological advancements to ensure continued relevance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Business Structure */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Business Structure
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ebusiness Marketing Group LLC operates as an umbrella entity, providing dual service lines while acting as an incubator for various DBAs.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-robot-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">AI Agency Services</h3>
              <p className="text-gray-600 mb-6">
                Cutting-edge artificial intelligence solutions for marketing transformation and business optimization.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>AI-Powered Analytics &amp; Insights:</strong> Deep market data analysis and consumer behavior insights
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Automated Marketing Optimization:</strong> Real-time campaign optimization and targeting
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Personalized Customer Experiences:</strong> Dynamic content and tailored communication
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>AI Strategy Consulting:</strong> Integration guidance and implementation roadmaps
                  </div>
                </li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-building-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Business Development Services</h3>
              <p className="text-gray-600 mb-6">
                Comprehensive support for establishing and growing new business entities with expert guidance.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Comprehensive Business Development:</strong> LLCs, Corporations, and DBA establishment
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Legal &amp; Compliance Consultation:</strong> Optimal structures and regulatory compliance
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Documentation &amp; Filing Management:</strong> Complete paperwork handling and submission
                  </div>
                </li>
                <li className="flex items-start text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                  <div>
                    <strong>Strategic Planning:</strong> Market entry strategies and business model development
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* VistaBoost Success Story */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-trophy-line mr-2"></i>
                DBA Success Story
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                VistaBoost Imaging: Our Proven Success Model
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                <strong>VistaBoost Imaging</strong> is a successful DBA operating under the Ebusiness Marketing Group LLC umbrella, exemplifying our capability in not only establishing but also nurturing specialized business units. This established photography and visual marketing division specializes in professional imaging services, brand photography, and visual content creation for businesses across various industries.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                VistaBoost demonstrates our end-to-end expertise in business formation, branding, and implementing effective marketing strategies. It leverages our internal AI Agency Services for its own marketing and operational efficiencies, showcasing a symbiotic relationship within our ecosystem.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                VistaBoost's rapid growth and strong market presence provide tangible proof of our ability to identify market needs, execute successful business launches, and drive significant growth from concept to market leadership.
              </p>
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600">500+</div>
                  <div className="text-gray-600">Projects Completed</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">3x</div>
                  <div className="text-gray-600">Revenue Growth</div>
                </div>
              </div>
              <Button href="/portfolio" variant="primary" className="whitespace-nowrap">
                View Success Stories
              </Button>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/ae4407479e028bd300c7f296be3e2784.jpg"
                alt="VistaBoost Imaging Success"
                className="rounded-2xl shadow-xl object-cover w-full h-96"
              />
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-6 shadow-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">Leader</div>
                  <div className="text-sm text-gray-600">Visual Marketing</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Analysis */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Market Leadership &amp; Analysis
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Positioned at the forefront of the rapidly expanding AI marketing and business development industries.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">AI Marketing Market Growth</h3>
              <p className="text-gray-600 mb-6">
                The global AI in marketing market was valued at over $12 billion in 2023 and is projected to grow at a CAGR of over 25% from 2024 to 2030, driven by demand for personalized experiences and data-driven decision-making.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">$12B+</div>
                  <div className="text-sm text-gray-600">Market Value 2023</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">25%</div>
                  <div className="text-sm text-gray-600">Annual Growth Rate</div>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
              <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-building-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Business Development Demand</h3>
              <p className="text-gray-600 mb-6">
                The entrepreneurial ecosystem remains robust with consistent new business registrations annually. High demand exists for expert guidance in legal entity development, compliance, and strategic planning.
              </p>
              <div className="space-y-3">
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Consistent market demand</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Complex regulatory navigation</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  <span>Strategic planning needs</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Competitive Advantage */}
          <div className="bg-gray-900 rounded-2xl p-8 lg:p-12 text-white">
            <div className="text-center mb-12">
              <h3 className="text-3xl font-bold mb-4">Our Competitive Advantage</h3>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Ebusiness Marketing Group LLC stands out with our dual-pronged, integrated approach that competitors cannot match.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-robot-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold mb-4">AI-First Marketing</h4>
                <p className="text-gray-300">
                  Deep AI expertise delivering superior marketing performance and insights that traditional agencies cannot provide.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-building-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold mb-4">Holistic Business Establishment</h4>
                <p className="text-gray-300">
                  End-to-end support from legal setup to integrated marketing strategy, ensuring ventures are built for success.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-trophy-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold mb-4">Proven Track Record</h4>
                <p className="text-gray-300">
                  VistaBoost Imaging demonstrates our ability to launch, brand, and market new entities effectively, differentiating us from theoretical consultants.
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-organization-chart text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-semibold mb-4">Umbrella Structure</h4>
                <p className="text-gray-300">
                  Our ability to launch and manage successful DBAs provides diversified revenue streams and synergistic operations.
                </p>
              </div>
            </div>
          </div>

          {/* Organization and Management */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Organization &amp; Management
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  A lean and agile organizational structure designed for maximum efficiency and client success.
                </p>
              </div>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
                  <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                    <i className="ri-team-line text-2xl text-blue-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Organizational Structure</h3>
                  <p className="text-gray-600 mb-6">
                    Ebusiness Marketing Group LLC operates with a lean and agile organizational structure. The leadership team directly oversees core functions, while project-based teams are assembled to leverage specialized skills for client engagements and DBA development.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Direct Leadership Oversight:</strong> Core functions managed by experienced leadership team
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Project-Based Teams:</strong> Specialized skills assembled for specific client engagements
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Agile Operations:</strong> Flexible structure adapting to client needs and market demands
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>DBA Development Focus:</strong> Dedicated resources for nurturing new business entities
                      </div>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
                  <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                    <i className="ri-lightbulb-line text-2xl text-green-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Strategic Advantages</h3>
                  <p className="text-gray-600 mb-6">
                    Our organizational approach maximizes efficiency while maintaining the flexibility to scale operations and adapt to evolving market conditions.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Lean Operations:</strong> Reduced overhead costs while maintaining high service quality
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Scalable Resources:</strong> Ability to expand teams based on project requirements
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Expertise Integration:</strong> Seamless collaboration between AI and business formation specialists
                      </div>
                    </li>
                    <li className="flex items-start text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                      <div>
                        <strong>Innovation Culture:</strong> Structure that promotes continuous learning and adaptation
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

        </div>
      </section>

      {/* Company Stats */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">
              Our Track Record
            </h2>
            <p className="text-xl text-blue-100">
              Numbers that speak to our commitment and success in AI marketing and business formation
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">AI</div>
              <div className="text-blue-200">Powered Solutions</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">100+</div>
              <div className="text-blue-200">Businesses Developed</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">500%</div>
              <div className="text-blue-200">Average ROI Increase</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">24/7</div>
              <div className="text-blue-200">AI Optimization</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Partner With Us?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Let's discuss how our AI expertise and business development services can help transform your vision into a successful, thriving enterprise.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button href="/contact" variant="primary" size="lg" className="whitespace-nowrap">
              Start Your Journey
            </Button>
            <Button href="/services" variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 whitespace-nowrap">
              Explore Our Services
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
